const createMarkHtmlDeserializer = (markType, tagMatcher, attributeMatcher) => ({
  processAttributesPaste: ({ element, cumulativeTextAttrs: cta }) => {
    return attributeMatcher(element) ? { ...cta, [markType]: true } : cta;
  },
  processInlinePaste: ({ element, next, cumulativeTextAttrs }) => {
    if (tagMatcher(element)) {
      return next(element.childNodes, { ...cumulativeTextAttrs, [markType]: true });
    }
    return null;
  }
});
export {
  createMarkHtmlDeserializer
};
//# sourceMappingURL=CustomMarkPlugin.js.map
